import AttendanceSerializer from './base';

export default class Register extends AttendanceSerializer {}
